const checkArmstrongCookie = () => {
  var _a;
  const cookies = globalThis.document ? globalThis.document.cookie : "";
  const armstrongFeatureCookie = cookies.split("; ").find((el) => el.startsWith("rm=")) || "";
  let hasCookie = Boolean(armstrongFeatureCookie.length);
  const parsedCookie = hasCookie ? JSON.parse(armstrongFeatureCookie.substring(3)) : {};
  hasCookie = ((_a = parsedCookie.featureSwitches) == null ? void 0 : _a.armstrong_v1) !== void 0;
  const isArmstrongUser = hasCookie ? parsedCookie.featureSwitches.armstrong_v1 : false;
  return { hasCookie, isArmstrongUser };
};
export {
  checkArmstrongCookie
};
